import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../../Services/common.service';
import { ConfigSettingService } from '../../../Services/config-setting.service';
import { DataManipService } from '../../../Services/data-manip.service';
import { DefaultLayoutComponent } from '../../../containers/default-layout/default-layout.component';
import { UpdateBalanceService } from '../../../Services/update-balance.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadTestModalComponent } from '../../download-test-modal/download-test-modal.component';
import { EncrptDecreptService } from '../../../Services/encrpt-decrept.service';


@Component({
  selector: 'app-myprofile',
  templateUrl: './myprofile.component.html',
  styleUrls: ['./myprofile.component.scss']
})
export class MyprofileComponent implements OnInit {

  @ViewChild('testModal', { static: false }) public testModal: ModalDirective;
  @ViewChild('downloadtestmodal', { static: false }) public downloadtestmodal: ModalDirective;
  @ViewChild('profileForm', { static: false }) public profileForm: NgForm;
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;

  message = ""
  showLoader: boolean = false;
  userName: string = "";
  gender: any = "";
  education: string = "";
  occupation: string = "";
  address: string = "";
  country: string = "";
  state: string = "";
  city: string = "";
  dob = new Date();
  age: number = null;
  prefLanguage: string = "";
  mobile: number = null;
  email: string = "";
  wallet: number = 0;
  noneditable: boolean = true;
  topupvisible: boolean = false;
  showUpdatedMsg: string = "";
  dobStr;
  registerby = ""
  testLanguages = [
    {
      "value": "e",
      "display": "English"
    },
    {
      "value": "m",
      "display": "Marathi"
    },
    {
      "value": "h",
      "display": "Hindi"
    }
  ]
  tableconfig = {};
  tableheaders = [];
  tabledata = [];
  showGtPlusTbl: boolean = false;
  imageSrc: string = '';

  constructor(public balanceUpdate: UpdateBalanceService,
    private defaultlayout: DefaultLayoutComponent,
    private router: Router, private datePipe: DatePipe,
    public dataManipSrvc: DataManipService, private ngbModal: NgbModal,
    private commonServices: CommonService, private configSetting: ConfigSettingService,
    private encryptService: EncrptDecreptService) {


    /* this.userName = balanceUpdate.userName;
     this.gender = balanceUpdate.gender;
     this.education = balanceUpdate.education;
     this.occupation = balanceUpdate.occupation;
     this.address = balanceUpdate.address;
     this.country = balanceUpdate.country;
     this.state = balanceUpdate.state;
     this.city = balanceUpdate.city;
     //this.dob = new Date(userData["dob"]);
     this.dobStr = balanceUpdate.dob;
     this.age = balanceUpdate.age;
     this.prefLanguage = balanceUpdate.prefLanguage;
     this.mobile = balanceUpdate.mobile;
     this.email = balanceUpdate.email;
     this.registerby=balanceUpdate.registerby*/
    this.wallet = this.commonServices.walletamount;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.dataManipSrvc.userimage = this.imageSrc;

      this.dataManipSrvc.headerName = "Profile";
    }, 80);
    //this.balanceUpdate.getUserDetails();
    this.getUserDetails();

  }

  ngOnDestroy() {
    // ...
  }

  openDownloadTestModal() {
    const ngbModalRef = this.ngbModal.open(DownloadTestModalComponent, { windowClass: "download-test-modal", backdrop: 'static', keyboard:false });
    ngbModalRef.componentInstance.userid = this.dataManipSrvc.userId;

    ngbModalRef.result.then((result) => {
//      console.log("result");

      if (result && result?.status == "finish") {

      }
    });
  }

  editProfile() {
    this.noneditable = false;
    this.showUpdatedMsg = "";
  }
  saveUserProfile() {

    this.showLoader = true;
    //this.dobStr=this.dob;
    if (!this.education) {
      this.education = "";
    } else if (!this.occupation) {
      this.occupation = "";
    } else if (!this.imageSrc) {
      this.imageSrc = "";
    }
    let apiUrl = this.configSetting.getBaseUrl() + "user/SaveUserMaster";
    // console.log(this.wallet);
    
    let body = {
      "dob": this.dobStr,
      "city": this.city,
      "state": this.state,
      "gender": this.gender,
      "userid": this.encryptService.encrypt(this.dataManipSrvc.userId),
      "address": this.address,
      "country": this.country,
      "emailid": this.email,
      "mobileno": this.mobile,
      "username": this.userName,
      "education": this.education,
      "occupation": this.occupation,
      "preflanguage": this.encryptService.encrypt(this.prefLanguage),
      "walletbalance": this.encryptService.encrypt(this.wallet+""),
      "userprofileimage": this.imageSrc,
      "registerby": this.registerby,

    }
    
    // console.log("Proflie JSON: ", JSON.stringify(body));
    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.showLoader = false;
        //console.log("Set Password .....", JSON.stringify(successResp)); 
        this.noneditable = true;
        this.showUpdatedMsg = "Profile successfully updated.";
        // this.userName = body['username']
        this.getUserDetails();
      }
      else {
        this.showLoader = false;
      }
    }, (err) => {
//      console.log(err);
      this.showLoader = false;
    })
  }

  getUserDetails() {

    this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getUserDetailByUserId";
    let body = {
      "userid": this.encryptService.encrypt(this.dataManipSrvc.userId+"")
    }

    // console.log("userid",this.dataManipSrvc.userId, JSON.stringify(body), body.userid);
    
    
    this.commonServices.getWithParams(apiUrl, body).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.showLoader = false;
        let userData = {};
        userData = successResp["Data"][0];
        this.userName = userData["username"];
        this.dataManipSrvc.userName = this.userName;
        this.dataManipSrvc.userimage = this.imageSrc;
        this.gender = userData["gender"];
        this.education = userData["education"];
        this.occupation = userData["occupation"];
        this.address = userData["address"];
        this.country = userData["country"];
        this.state = userData["state"];
        this.city = userData["city"];
        this.dob = new Date(userData["dob"]);
        this.dobStr = userData["dob"];
        this.dataManipSrvc.dob = this.dob;
        this.age = userData["age"];
        this.prefLanguage = userData["preflanguage"];
        this.mobile = userData["mobileno"];
        this.email = userData["emailid"];
        this.registerby = userData["registerby"];
        this.imageSrc = userData["userprofileimage"];
        if (this.occupation == "null" || this.education == "null") {
          this.occupation = "";
          this.education = "";
        }
        // this.wallet = userData["walletbalance"];
        this.commonServices.walletamount = userData["walletbalance"];
        // this.getAllTests();
        this.wallet = this.commonServices.walletamount;

      } else {
        this.showLoader = true;
      }
    }, (err) => {
      this.showLoader = true;
    })
  }

  calculateAge() {

    let timeDiff = Math.abs(Date.now() - this.dob?.getTime());
    this.age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    this.dobStr = this.datePipe.transform(this.dob, "yyyy-MM-dd")
  }

  getAllTests() {
    this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getuserTakingtestList";
    let body = {
      "userid": this.dataManipSrvc.userId
    }

    this.commonServices.getWithParams(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        this.tableheaders = successResp["Data"]["tableheaders"];
        this.tableconfig = successResp["Data"]["tableconfig"];
        this.tabledata = successResp["Data"]["tabledata"];


      }
    })
  }
  showMyTestModal() {
    this.openDownloadTestModal();
    // this.downloadtestmodal.show();
    // this.showGtPlusTbl = true;
  }

  downloadReport(event) {
    this.showLoader = true;
    let params =
    {
      "userid": this.encryptService.encrypt(this.dataManipSrvc.userId+""),
      "testid": this.encryptService.encrypt(event["row"]["testid"]+""),
      "usertestid": this.encryptService.encrypt(event["row"]["usertestid"]+"")
    };
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/downloadResultPDF";
    this.commonServices.downloadReport(apiUrl, params).subscribe(successResp => {

      var blob = new Blob([successResp], { type: 'application/pdf' });
      var url = window.URL.createObjectURL(blob);
      let testDate = this.datePipe.transform(event["row"]["testcompletedon"], "dd-MMM-yyyy_HH:MM");
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      //  a.download = this.userTests[i]["testname"]["testname"] + "_" + testDate;
      a.download = event["row"]["testname"] + "_" + event["row"]["usertestid"] + "_" + testDate;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.showLoader = false;
    },
      err => {
        alert("Problem while downloading the file.");

        console.error(err);
      }
    );
  }
  downloadtestmodalcloseevt() {
    this.downloadtestmodal.hide();
    this.showGtPlusTbl = false;
  }
  openTopUp() {
    this.message = "Proceed"
    // this.successModal.show();
    this.defaultlayout.displaywalletpoppup("profile");



  }
  closeupdateUsermodal() {
    this.noneditable = true;
    this.showUpdatedMsg = "";
    if(this.dataManipSrvc.isadmin){
      this.router.navigateByUrl('/usermanagement');
    }else{
      this.router.navigateByUrl('/dashboard');
    }
  }
  ClosesuccessModal() {
    this.getUserDetails();
    this.successModal.hide();

  }


  handleInputChange(e) {
    // console.log(this.noneditable);

    if (this.noneditable) {
      return 0;
    }
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    this.imageSrc = reader.result;
    // console.log(this.imageSrc)
  }

  checkRecComment() {
    let inputBox = document.getElementById("mobileno");
    
    let invalidChars = ["e", "+", "-"]

    inputBox.addEventListener("keydown", function (e) {
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });
  }
}
